export const manifest = {
  screens: {
    scr_ipou6u: { name: "Communications · Liste des avis", route: "/", state: {"activeTab":"bciti","activeSubTab":"gerer","gererView":"list"}, position: {"x":160,"y":220} },
    scr_pvemga: { name: "Communications · Créer un avis", route: "/", state: {"activeTab":"bciti","activeSubTab":"gerer","gererView":"composer"}, position: {"x":1560,"y":220} },
    scr_i9cyg7: { name: "Communications Analytics", route: "/", state: {"activeTab":"bciti","activeSubTab":"analytiques"}, position: {"x":160,"y":4180} },
    scr_8uzy7y: { name: "Requêtes Analytics", route: "/", state: {"activeTab":"requetes","activeSubTab":"analytiques"}, position: {"x":1560,"y":4180} },
    scr_kbbiic: { name: "ATNA AI", route: "/", state: {"activeTab":"atna"}, position: {"x":160,"y":6160} },
    scr_e25vt8: { name: "Permis", route: "/", state: {"activeTab":"permis","activeSubTab":"gerer"}, position: {"x":160,"y":8140} },
  },
  sections: {
    sec_g0pp7y: { name: "BCITI Communications", x: 0, y: 0, width: 2920, height: 1180 },
    sec_n0sdmd: { name: "User Management", x: 0, y: 1980, width: 1520, height: 1180 },
    sec_wnx345: { name: "Analytics Dashboard", x: 0, y: 3960, width: 2920, height: 1180 },
    sec_9zjn3f: { name: "ATNA AI", x: 0, y: 5940, width: 1520, height: 1180 },
    sec_5yu307: { name: "BCITI Permis", x: 0, y: 7920, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_g0pp7y", children: [
      { kind: "screen", id: "scr_ipou6u" },
      { kind: "screen", id: "scr_pvemga" },
    ] },
    { kind: "section", id: "sec_n0sdmd", children: [
      { kind: "screen", id: "scr_bn3iwu" },
    ] },
    { kind: "section", id: "sec_wnx345", children: [
      { kind: "screen", id: "scr_i9cyg7" },
      { kind: "screen", id: "scr_8uzy7y" },
    ] },
    { kind: "section", id: "sec_9zjn3f", children: [
      { kind: "screen", id: "scr_kbbiic" },
    ] },
    { kind: "section", id: "sec_5yu307", children: [
      { kind: "screen", id: "scr_e25vt8" },
    ] },
  ],
}
